import styled, { css } from "styled-components";
import { BLUE, LIGHT_GRAY } from "../../config";

export const Footer = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  button {
    margin-right: 16px;
  }
`;

export const Box = styled.div`
  height: auto;
  width: 100%;

  h4 {
    margin: 0px;
    margin-bottom: 1rem;
  }
`;

export const Border = styled.div<{ isSelected: boolean }>`
  border-radius: 10px;
  border: ${({ isSelected }) => (isSelected ? `2px solid ${BLUE}` : `1px solid ${LIGHT_GRAY}`)};
  padding: 15px;
  margin: 15px 0px;
  margin-right: 8px;
`;

export const Container = styled.div<{ isSelected: boolean }>`
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  word-wrap: break-word;
  height: 50px;
  cursor: pointer;
  line-height: 25px;
  text-align: justify;

  ${({ isSelected }) =>
    isSelected &&
    css`
      -webkit-line-clamp: inherit;
      height: auto;
      display: flex;
      justify-content: space-between;
      overflow: visible;
    `}
`;
